import React from 'react';
import { DoubleChainActionIcon } from 'components/ScenarioSetup/ActionIcons/DoubleChainActionIcon';
import { EditSegmentIcon } from 'assets/icons/EditSegmentIcon';
import { EditSegmentIconAlt } from 'assets/icons/EditSegmentIconAlt';

export const EditSegment = ({ id, actionType, title, isShowWarningActionMessage, isOpenActionInfo }) => {

    const actionIconConditions = {
        base: {
            icon: EditSegmentIcon,
            iconProps: {
                width: '48px',
                height: '48px',
                color: '#FFFFFF',
                bgColor: '#0CBFE7'
            }
        },
        opened: {
            icon: EditSegmentIconAlt,
            iconProps: { borderColor: '#0CBFE7' }
        },
        warning: {
            icon: EditSegmentIconAlt,
            iconProps: { borderColor: '#FC4A54' }
        }
    }

    return <DoubleChainActionIcon {...{
        id,
        actionType,
        title,
        isShowWarningActionMessage,
        isOpenActionInfo,
        actionIconConditions,
    }} />
}
